// @ts-check
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

/**
 * @param {Object} props
 * @param {string} props.slogan
 * @param {string} props.buttonLabel
 * @param {string} [props.category]
 */
export function defaultSocialImage({
  slogan = 'Get the cover you need in minutes',
  buttonLabel = 'Find out more',
  category = undefined,
}) {
  const url = new URL('/default', 'https://zego-og-images.now.sh');
  url.searchParams.set('slogan', slogan);
  url.searchParams.set('buttonLabel', buttonLabel);

  if (category) {
    url.searchParams.set('category', category);
  }

  if (publicRuntimeConfig.VERSION) {
    url.searchParams.set('v', publicRuntimeConfig.VERSION);
  }

  return url.toString();
}
